export class GatewayPayment {
}
